import React, { Fragment } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import i18n from "i18next";
import { useTranslation } from 'react-i18next';

import {agp} from './imageLanguageHandler/agp.js';
import {day} from './imageLanguageHandler/day.js';
import {request} from './imageLanguageHandler/request.js';
import {statistic} from './imageLanguageHandler/statistic.js';

function Practitioners() {
  const { t } = useTranslation('help');
  return (
    <Fragment>
      <h1>{t('For practitioners')}</h1>
      <p>{t('Estimated reading time')} 4 {t('minutes.')}</p>
      <section id="startup">
        <h2>{t('Launch from the EHR')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('ForPractitioner-LaunchChapter1')}
        </p>
      </section>
      <section id="dataAccess">
        <h2>{t('Ask for permissions')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('ForPractitioner-PermissionChapter1')}
        </p>
        <p>
          {t('ForPractitioner-PermissionChapter2')}
        </p>
        <p>
          <img 
            src={request[i18n.language]?.() || request['en']()}
            alt={t('Data sharing request')}
          />
        </p>
      </section>
      <section id="dataUsage">
        <h2>{t('Inspect the graphs')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('ForPractitioner-InspectChapter1')} <a
          href={t('ForPractitioner-InspectChapter1Link')}>{t('ForPractitioner-InspectChapter1LinkText')}</a>{t('ForPractitioner-InspectChapter1End')}
        </p>
        <p>
          <img 
            src={agp[i18n.language]?.() || agp['en']()}
            alt={t('AGP report')} 
          />
        </p>
        <p>
          {t('ForPractitioner-InspectChapter2')}
        </p>
        <p>
          {t('ForPractitioner-InspectChapter3')}
        </p>
        <p>
          <img 
            src={day[i18n.language]?.() || day['en']()}
            alt={t('Daily view')} 
          />
        </p>
      </section>
      <section id="toPatientSystem">
        <h2>{t('Copy information to the EHR')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('ForPractitioner-CopyInfoChapter1')}
        </p>
        <p>
          <img 
            src={statistic[i18n.language]?.() || statistic['en']()}
            alt={t('Statistics')} 
          />
        </p>
      </section>
    </Fragment>
  );
}

export default Practitioners;